export const COOKIE_TOKEN_NAME = "_dmal_jwttoken"
export const COOKIE_MAX_AGE = 7; // days
export const COOKIE_REMEMBER_ME = "rememberMe";